import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import ReCAPTCHA from "react-google-recaptcha";

export default function ContactForm() {
  const form = useRef();
  const recaptchaRef = useRef(); // Riferimento per il CAPTCHA
  const [isLoading, setIsLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null); // Stato per il CAPTCHA

  const sendEmail = (e) => {
    e.preventDefault();

    if (!form.current.privacy.checked) {
      setStatusMessage("⚠ Devi accettare l'informativa sulla privacy per inviare il preventivo.");
      return;
    }

    if (!captchaToken) {
      setStatusMessage("⚠ Conferma di non essere un robot con il CAPTCHA.");
      return;
    }

    setIsLoading(true);
    setStatusMessage("");

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          setIsLoading(false);
          setStatusMessage("✅ Preventivo inviato con successo!");
          form.current.reset();
          recaptchaRef.current.reset(); // Resetta il CAPTCHA
          setCaptchaToken(null); // Resetta il token

          setTimeout(() => {
            window.location.href = "/";
          }, 1000);
        },
        (error) => {
          console.log(error.text);
          setStatusMessage("❌ Errore nell'invio dell'email. Riprova più tardi.");
          setIsLoading(false);
        }
      );
  };

  return (
    <form
      ref={form}
      onSubmit={sendEmail}
      className="max-w-md mx-auto p-4 border rounded-xl shadow-2xl shadow-logo-color"
    >
      <h2 className="text-2xl font-bold">Richiedi un preventivo!</h2>
      <p className="text-sm mb-4">Inserendo i dati e cliccando invia invierai una richiesta di preventivo al team di DOT Serramenti.</p>

      <div className="mb-4">
        <label className="block font-medium mb-1">Indirizzo Email</label>
        <input type="email" name="user_email" required className="w-full px-4 py-2 border rounded-lg" />
      </div>

      <div className="mb-4">
        <label className="block font-medium mb-1">Nome e Cognome</label>
        <input type="text" name="user_name" required className="w-full px-4 py-2 border rounded-lg" />
      </div>

      <div className="mb-4">
        <label className="block font-medium mb-1">Numero di Telefono</label>
        <input type="tel" name="user_phone" required className="w-full px-4 py-2 border rounded-lg" />
      </div>

      <div>
        <label className="block font-medium mb-1">Messaggio</label>
        <textarea name="message" required className="w-full px-4 py-2 border rounded-lg min-h-52" />
      </div>

      <div className="flex mb-4">
        <input type="checkbox" id="privacy" name="privacy" />
        <p className="text-sm ml-2">Confermo di aver preso visione dell’informativa sulla privacy.</p>
      </div>

      {/* Google reCAPTCHA */}
      <div className="mb-4">
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY} // 🔹 Inserisci la tua Site Key di Google reCAPTCHA
          onChange={(token) => setCaptchaToken(token)}
        />
      </div>

      <button
        type="submit"
        disabled={isLoading}
        className={`w-full py-2 rounded-lg ${isLoading ? "bg-gray-400 cursor-not-allowed" : "bg-logo-color hover:bg-blue-600 text-white"}`}
      >
        {isLoading ? "Invio in corso..." : "Invia"}
      </button>

      {/* Messaggio di stato */}
      {statusMessage && (
        <p className={`mt-4 text-center font-semibold ${statusMessage.includes("Errore") ? "text-red-500" : "text-green-500"}`}>
          {statusMessage}
        </p>
      )}

      {/* Indicatore di caricamento */}
      {isLoading && (
        <div className="mt-4 text-center">
          <svg
            className="animate-spin h-6 w-6 text-blue-500 mx-auto"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
          </svg>
          <p className="text-sm text-gray-500">Invio in corso, attendere...</p>
        </div>
      )}
    </form>
  );
}
